import React from "react";
import { useNavigate } from "react-router-dom";
import useTranslationHook from "../hooks/useTranslationHook";
import { discoverFilters, statusOptions } from "../../utils/constants";
import ReactSelect from "../common/ReactSelect";
import {
    resetFilter,
    resetSearchFilter,
    setFilter,
} from "../../redux/slice/discoverSlice";
import { sellerAction } from "../../redux/action/sellerAction";
import { useDispatch, useSelector } from "react-redux";
import SearchInput from "../common/SearchInput";
const FilterModal = ({ show, onClose, handleManualSearch }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslationHook();
    const search = useSelector((state) => state.discover.search);
    const cities = useSelector((state) => state.seller.cities);
    const municipalities = useSelector((state) => state.seller.municipalities);
    const districts = useSelector((state) => state.seller.districts);
    const propertyTypes = useSelector((state) => state.seller.propertyTypes);
    const property_type = useSelector((state) => state.discover.property_type);
    const status = useSelector((state) => state.discover.status);
    const city = useSelector((state) => state.discover.city);
    const municipality = useSelector((state) => state.discover.municipality);
    const district = useSelector((state) => state.discover.district);
    const construction_status = useSelector(
        (state) => state.discover.construction_status
    );
    const constructionStatus = useSelector(
        (state) => state.seller.constructionStatus
    );
    const filter_beds = useSelector((state) => state.discover.filter_beds);
    const filter_baths = useSelector((state) => state.discover.filter_baths);
    const property_for = useSelector((state) => state.discover.property_for);

    return (
        <div
            className={`modal fade place-bid-modal ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
        >
            <div className="filter-popup modal-dialog modal-dialog-centered modal-sm">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>All Filters</h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            aria-label="Close"
                        ></button>
                    </div>

                    <div className="mb-3">
                        <div className="search-box">
                            <button className="search-btn">
                                <img src="img/search-icon.svg" alt="" />
                            </button>
                            <SearchInput
                                onSearch={(query) =>
                                    dispatch(setFilter({ search: query }))
                                }
                                minChars={1}
                                value={search}
                                searchBoxClassName="form-control"
                                placeholder={t("SearchByAreaOrLocation")}
                                reset={search === "" ? true : false}
                            />
                        </div>
                    </div>
                    <ul className="filters-list">
                        {discoverFilters?.map((ele, ind) => {
                            const options =
                                ele.name === "district"
                                    ? districts
                                    : ele.name === "municipality"
                                        ? municipalities
                                        : ele.name === "city"
                                            ? cities
                                            : ele.name === "property_type"
                                                ? propertyTypes
                                                : ele.name === "construction_status"
                                                    ? constructionStatus
                                                    : ele.name === "status"
                                                        ? statusOptions
                                                        : ele.options;
                            const selectedValue =
                                ele.name === "filter_beds"
                                    ? filter_beds
                                    : ele.name === "filter_baths"
                                        ? filter_baths
                                        : options.find(
                                            (opt) =>
                                                opt.value ===
                                                (ele.name === "property_for"
                                                    ? property_for
                                                    : ele.name === "district"
                                                        ? district
                                                        : ele.name ===
                                                            "municipality"
                                                            ? municipality
                                                            : ele.name === "city"
                                                                ? city
                                                                : ele.name ===
                                                                    "property_type"
                                                                    ? property_type:
                                                                    ele.name ===
                                                                    "status"
                                                                    ? status
                                                                    : construction_status)
                                        ) || "";
                            return (
                                <li key={ind}>
                                    <ReactSelect
                                        name={ele.name}
                                        isMulti={ele.isMulti}
                                        isClearable={false}
                                        options={options}
                                        isSearchable={true}
                                        placeholder={t(ele.placeholder)}
                                        className="select"
                                        value={selectedValue}
                                        onChange={(dropDownValues) => {
                                            let value = ele.isMulti
                                                ? dropDownValues
                                                : dropDownValues.value;
                                            dispatch(
                                                setFilter({
                                                    [ele.name]: value,
                                                })
                                            );
                                        }}
                                    />
                                </li>
                            );
                        })}
                        {/* <li>
                            {
                                (filter_baths.length ||
                                    filter_beds.length ||
                                    construction_status ||
                                    property_type ||
                                    city ||
                                    municipality ||
                                    district) && <button
                                        title={t("Clear all filters")}
                                        // disabled={
                                        //     // !search &&
                                        //     !filter_baths &&
                                        //     !filter_beds &&
                                        //     !construction_status &&
                                        //     !property_type &&
                                        //     !city &&
                                        //     !municipality &&
                                        //     !district
                                        // }
                                        onClick={() => {
                                            dispatch(resetFilter());
                                            dispatch(
                                                sellerAction.handleSetMunicipalities(
                                                    []
                                                )
                                            );
                                            dispatch(
                                                sellerAction.handleSetDistricts([])
                                            );
                                        }}
                                    >
                                    <img
                                        src="/img/close-gray.svg"
                                        alt={t("Clear all filters")}
                                    />
                                </button>

                            }

                        </li> */}
                    </ul>

                    <div className="filter-bottom">
                        <div className="">
                            <button
                                className="btn btn-sky btn-full"
                                onClick={() => {
                                    dispatch(resetSearchFilter());
                                }}
                            >
                                {t("Clear all filters")}
                            </button>
                        </div>
                        <div className="">
                            <button
                                className="btn btn-primary btn-full"
                                onClick={() => {
                                    handleManualSearch();
                                    onClose();
                                }}
                            >
                                {t("Search")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FilterModal;
